import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router";

import { getSession } from "@/services/auth";

// Wraps /login, /signup and /forgot-password: a visitor who is already
// signed in is sent to the dashboard — or, when the URL carries an
// invite token (?invite=…), straight to /join/<token> so they can accept
// it in one click. Renders nothing while the session check is in flight
// so the form never flashes for a signed-in user.
export default function GuestOnly() {
  const [signedIn, setSignedIn] = useState<boolean | null>(null);
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    getSession().then(({ session }) => {
      if (!cancelled) setSignedIn(!!session);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (signedIn === null) return null;
  if (signedIn) {
    const invite = searchParams.get("invite");
    const target =
      invite && (pathname === "/login" || pathname === "/signup")
        ? `/join/${encodeURIComponent(invite)}`
        : "/dashboard";
    return <Navigate to={target} replace />;
  }
  return <Outlet />;
}
